import { FaShoppingCart, FaStar } from 'react-icons/fa';
import { useCart } from '../../context/CartContext';
import './Products.css';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product);
    alert(`${product.name} कार्टमा थपियो!`);
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'आलु':
        return '#4CAF50';
      case 'प्याज':
        return '#FF9800';
      case 'लसुन':
        return '#9C27B0';
      case 'अदुवा':
        return '#F44336';
      case 'संग्रह':
        return '#2196F3';
      default:
        return '#607D8B';
    }
  };

  return (
    <div className="product-card">
      {/* Product Image */}
      <div className="product-image-container">
        <div className="product-image" style={{ backgroundColor: `${getCategoryColor(product.category)}20` }}>
          <span className="product-emoji">{product.image}</span>
        </div>
        <div className="product-category" style={{ backgroundColor: getCategoryColor(product.category) }}>
          {product.category}
        </div>
        {product.rating && (
          <div className="product-rating">
            <FaStar className="star-icon" />
            <span>{product.rating}</span>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="product-info">
        <div className="product-header">
          <h3>{product.name}</h3>
          <div className="product-region">
            <span className="region-icon">📍</span>
            {product.region}
          </div>
        </div>

        <p className="product-description">{product.description}</p>

        <div className="product-footer">
          <div className="price-section">
            <div className="price-label">मूल्य:</div>
            <div className="price">₹{product.price}<span className="price-unit">/किलो</span></div>
          </div>

          <button
            className="add-to-cart-btn"
            onClick={handleAddToCart}
            style={{ backgroundColor: getCategoryColor(product.category) }}
          >
            <FaShoppingCart className="cart-icon" />
            कार्टमा थप्नुहोस्
          </button>
        </div>
      </div>

      {/* Product Features */}
      <div className="product-features">
        <div className="feature">
          <span className="feature-icon">🌱</span>
          <span>ताजा</span>
        </div>
        <div className="feature">
          <span className="feature-icon">🏔️</span>
          <span>स्थानीय</span>
        </div>
        <div className="feature">
          <span className="feature-icon">⭐</span>
          <span>उत्कृष्ट</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;